(function(global) {
    'use strict';

    document.addEventListener('DOMContentLoaded', () => {
        initClosestPolyfill(Element.prototype);

        //Устанавливаем обработчик клика на кнопку 'Подробнее' в рекламном объявлении
        global.Utils.addEventListener('click', document, 'js-btn-show-adve-action', onButtonShowActionClick);

        //Устанавливаем обработчик клика на кнопку 'Закрыть' в окне 'Действий' рекламного объявления
        global.Utils.addEventListener('click', document, 'js-btn-close-adve-action', hideAllBlocksActions);

        //Устанавливаем обработчик клика на кнопку 'Сохранить результат действий' в окне 'Действий' рекламного объявления
        global.Utils.addEventListener('click', document, 'js-btn-save-adve-action', onButtonSaveActionClick);

        global.Utils.addEventListener('change', document, 'js-adve-action__contact-time', onContactTimeChange);


        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('click', onWindowClick);
    });

    function showBlockAction(element) {
        if (!element) {
            return;
        }

        let itPhone = element.querySelector('input[name="PHONE"]');
        if (itPhone) {
            MaskIt('+7 (000) 000-0000', itPhone);
        }

        element.classList.add('adve-action--show');
        element.querySelector('[autofocus]').focus();

        element.addEventListener('input', onFormInput);
    }

    function hideAllBlocksActions() {
        let elements = document.querySelectorAll('.js-adve-action');
        if (!elements) {
            return;
        }

        [].forEach.call(elements, (element) => {
            element.classList.remove('adve-action--show');
        });
    }

    function getBlockAction(element) {
        let advertisement = element.closest('.js-adve');
        if (!advertisement) {
            return null;
        }

        return advertisement.querySelector('.js-adve-action');
    }

    /**
     * Выполняет сохранение данных из указанной формы
     *
     * @param {HTMLElement} form
     *
     */
    function saveAction(form) {
        if (!isSpecifiedContacts(form)) {
            noty({
                text: 'Необходимо указать номер телефона или электронный адрес!',
                type: 'error',
                speed: 500,
                timeout: 4000
            });
            return;
        }

        let formData = new FormData(form);
        let request = new XMLHttpRequest();

        request.open('POST', '/adve/save_activity_in_adve', true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        request.onreadystatechange = function() {
            if (request.readyState != 4) {
                return;
            }

            processingResponse(form, request);
        };

        request.send(formData);

        form.elements.btnSave.disabled = true;
        form.elements.btnSave.classList.add('is-loading');
    }

    /**
     * Производит обработку полученных данных
     *
     * @param {HTMLElement} form
     * @param {Object} request
     *
     */
    function processingResponse(form, request) {
        let responseText = request.responseText;

        form.elements.btnSave.disabled = false;
        form.elements.btnSave.classList.remove('is-loading');

        if ((request.status !== 200) || !responseText) {
            responseText = '{"result":"error","message":""}';
        }

        let response = stringToObject(responseText);
        if (!response.result || (response.result !== 'ok')) {
            noty({
                text: response.message || 'Ошибка!',
                type: 'error',
                speed: 500,
                timeout: 4000
            });

            return;
        }

        clearControls(form);

        form.elements.btnSave.disabled = true;
        hideAllBlocksActions();

        noty({
            text: 'Заявка успешно отправлена!',
            type: 'success',
            speed: 500,
            timeout: 4000
        });

        sendGAEvent({
            eventCategory: 'Реклама',
            eventAction: 'Заявка отправлена',
            eventLabel: ''
        });
    }

    function clearControls(form) {
        let controlNames = ['EMAIL', 'PHONE', 'DESCRIPTION', 'SECTION_MEDICINE_CODE'];

        controlNames.forEach((controlName) => {
            if (form.elements[controlName]) {
                form.elements[controlName].value = null;
            }
        });

    }

    /**
     * Определяет указаны ли контакты
     *
     * @param {HTMLElement} form
     *
     * @return {Boolean}
     */
    function isSpecifiedContacts(form) {
        return (form.elements.EMAIL.value || form.elements.PHONE.value);
    }

    /**
     * Обработка события: ввод данных в полях формы
     *
     * @param {HTMLElement} form
     *
     * @return {HTMLElement}
     */
    function getButtonSaveByForm(form) {
        return form.querySelector('.js-btn-save-adve-action');
    }

    function stringToObject(string) {
        try {
            return JSON.parse(string);
        } catch (err) {
            return {};
        }
    }

    function initClosestPolyfill(el) {
        if (el.closest) {
            return;
        }

        el.closest = function(css) {
            let node = this;

            while (node) {
                if (node.matches(css)) return node;
                else node = node.parentElement;
            }

            return null;
        };
    }

    function sendGAEvent(data) {
        if (typeof ga !== 'function') {
            return;
        }

        ga('send', {
            hitType: 'event',
            eventCategory: 'Реклама',
            eventAction: data.eventAction,
            eventLabel: data.eventLabel
        });
    }

    /**
     * Обработка события: клика по кнопке 'Подробнее' (показать форму действий/активности)
     *
     */
    function onButtonShowActionClick(evt) {
        let blockAction = getBlockAction(evt.target);
        if (!blockAction) {
            return;
        }

        if (blockAction.classList.contains('adve-action--show')) {
            hideAllBlocksActions();
            return
        }

        hideAllBlocksActions();
        showBlockAction(blockAction);
    }

    /**
     * Обработка события: клика по кнопке 'Сохранить активность'
     *
     */
    function onButtonSaveActionClick(evt) {
        evt.preventDefault();

        saveAction(evt.target.form);
    }

    /**
     * Обработка события: ввод данных в полях формы
     *
     */
    function onFormInput(evt) {
        let btnSave = getButtonSaveByForm(evt.target.form);
        btnSave.disabled = !evt.target.form.checkValidity();
    }

    /**
     * Обработка события: нажатия клавиши
     *
     */
    function onKeyDown(evt) {
        if (evt.keyCode === 27) {
            hideAllBlocksActions();
        }
    }

    function onWindowClick(evt) {
        if (evt.target.classList.contains('js-btn-show-adve-action')
            || evt.target.closest('.js-adve-action')) {
            return;
        }

        hideAllBlocksActions();
    }

    function onContactTimeChange(evt) {
        deactivationBtnGroup(evt.target.closest('.btn-group'));

        evt.target.closest('.btn').classList.add('active');
    }

    function deactivationBtnGroup(btnGroup) {
        if (!btnGroup) {
            return;
        }

        let activeButtons = btnGroup.querySelectorAll('.btn.active');
        if (!activeButtons) {
            return;
        }

        [].forEach.call(activeButtons, (button) => {
            button.classList.remove('active');
        });
    }

})(window);